// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg{background:#fff;padding:1rem}`, "",{"version":3,"sources":["webpack://./src/components/custom/styles.scss"],"names":[],"mappings":"AAAA,IACI,eAAA,CACA,YAAA","sourcesContent":[".bg {\r\n    background: #ffff;\r\n    padding: 1rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
